
// Debounce function
function cap_alg_debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

const snippet_class = ".ais-Snippet";
const snippet_tag = ".ais-Snippet-highlighted";

// find all snippet divs on the page, if there are no results then hide the snippet.
const hide_unused_snippets = cap_alg_debounce(() => {
    jQuery(snippet_class).each(function(i, element) {
        if (jQuery(element).find(snippet_tag).length > 0) {
            jQuery(element).css('display', 'block');
        } else {
            jQuery(element).css('display', 'none');
        }
    });
}, 250, false);

export default hide_unused_snippets;